<template>
  <multi-input :compress="compress">
    <column>
      <div class="sr-only">
        <label for="min_value">Min Value</label>
      </div>
      <input
        id="min_value"
        type="number"
        v-model.number="minValue"
        placeholder="Min Value"
        :disabled="disabled"
      />
    </column>
    <column>
      <div class="sr-only">
        <label for="max_value">Max Value</label>
      </div>
      <input
        id="max_value"
        type="number"
        v-model.number="maxValue"
        placeholder="Max Value"
        :disabled="disabled"
      />
    </column>
  </multi-input>
</template>

<script lang="ts">
  import Vue from "vue";
  import {INumericMinMaxable} from "../interfaces/propertyInterfaces";
  import disabledMixin from "../mixins/disabledMixin";

  export default Vue.extend({
    mixins: [disabledMixin],
    props: {
      model: {
        type: Object as () => INumericMinMaxable,
        required: true,
      },
      compress: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {};
    },
    computed: {
      minValue: {
        get(): any {
          return this.model.min_value;
        },
        set(value): any {
          this.model.min_value = value === '' ? null : value;
        }
      },
      maxValue: {
        get(): any {
          return this.model.max_value;
        },
        set(value): any {
          this.model.max_value = value === '' ? null : value;
        }
      },
    }
  });
</script>
